import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { listenForForegroundNotifications, notificationRouteFromData, syncWebNotificationToken } from '../services/notificationService';
import './NotificationBridge.css';

export default function NotificationBridge() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);

  useEffect(() => { if (user?.uid) syncWebNotificationToken(user.uid); }, [user?.uid]);

  useEffect(() => {
    let unsubscribe = () => {};
    let alive = true;
    listenForForegroundNotifications((payload) => {
      if (!alive) return;
      setNotice({
        title: payload.notification?.title || payload.data?.title || 'Pool 4 Real',
        body: payload.notification?.body || payload.data?.body || 'You have a new update.',
        data: payload.data || {},
      });
    }).then((off) => { if (alive) unsubscribe = off; else off?.(); });
    return () => { alive = false; unsubscribe?.(); };
  }, []);

  useEffect(() => {
    if (!notice) return undefined;
    const timer = window.setTimeout(() => setNotice(null), 7000);
    return () => window.clearTimeout(timer);
  }, [notice]);

  if (!notice) return null;
  return (
    <button type="button" className="p4r-foreground-notice" onClick={() => { navigate(notificationRouteFromData(notice.data)); setNotice(null); }}>
      <strong>{notice.title}</strong><span>{notice.body}</span>
    </button>
  );
}
